import queryString from "query-string";

import { chosenSites } from "app/common/services/chosenSites";
import DurationService from "app/services/DurationService";

export const calculateTotalCount = (queryParams: Record<string, unknown>): number => {
    const durationNum = DurationService.getMonthsFromApiDuration(
        queryParams?.from as string,
        queryParams?.to as string,
        queryParams?.isWindow as boolean | undefined,
    );
    const numOfSites = chosenSites.count();
    return numOfSites * durationNum;
};

export const buildExcelDownloadUrl = (prefix: string, apiParams: Record<string, unknown>): string => {
    return `${prefix}?${queryString.stringify(apiParams)}`;
};
